/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import CountryCodeStore from '@app/stores/CountryCodeStore';
import type {GatewayHandlerContext} from '@app/stores/gateway/handlers';
import MessageStore from '@app/stores/MessageStore';

interface ResumedPayload {
	country_code?: string;
	latitude?: string;
	longitude?: string;
}

export function handleResumed(data: unknown, context: GatewayHandlerContext): void {
	if (typeof data === 'object' && data !== null) {
		const payload = data as ResumedPayload;
		if (payload.country_code) {
			CountryCodeStore.setCountryCode(payload.country_code);
		}
		context.setConnectionGeoip({
			country_code: payload.country_code,
			latitude: payload.latitude,
			longitude: payload.longitude,
		});
	}

	MessageStore.handleResumed();
}
